// Module
var code = `<div class="statament-panel">
    <div class="statament-panel-container-top">
        <rangeSelectPanel name='statementPanelRangeSelect' refreshBtnVisibility={{true}} />
    </div>

    <div class="statament-panel-container-table">
        <terceraPanel name="windowPanelBodyQT" />

        {{#unless .isDataExist}}
            <div class="statament-panel-noData">
                {{>noDataPart}}
            </div>
        {{/unless}}
    </div>
</div>
`;
// Exports
export default code;